import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { gsap } from "gsap";

// fv init
(function fvInit() {
  if (window.innerWidth < 750) {
    const animationLayer = document.querySelector('.fv__main__animation-layer');
    const bgLayerImg = document.querySelector('.fv__main__bg img');

    animationLayer.style.width = `${bgLayerImg.clientWidth}px`;
  }
})();

loadingAnimation();
function loadingAnimation() {
  let loadingState = false;
  const loadingLayer = document.querySelector('.loading');
  const fvHeading = document.querySelector('.fv__heading');
  const animationText = document.querySelectorAll('.alphabet');
  const tl = gsap.timeline({ repeat: -1 });
  const loadingController = () => {
    setTimeout(() => {
      if (loadingState) {
        loadingLayer.classList.add('hidden');
        fvHeading.classList.add('visible');
        animateFv();
      } else {
        setTimeout(() => {
          loadingLayer.classList.add('hidden');
          fvHeading.classList.add('visible');
          animateFv();
        }, 6000);
      }
    }, 2000);
  }

  animationText.forEach((elm) => {
    tl.to(elm, { y: '-0.5rem', ease: "steps(1)", duration: 0.3, yoyo: true, repeat: 1, });
  });

  // ローディングアニメーションの時間管理
  loadingController();

  window.addEventListener('load', (event) => {
    loadingState = true;
  });
}

// リサイズされたら強制リロード
resizeToReload();
const initialWidth = window.innerWidth;
function resizeToReload() {
  window.addEventListener('resize', () => {
    const resizeWidth = window.innerWidth;

    if (initialWidth !== resizeWidth) {
      location.reload();
    }
  });
}

// ファーストビューのアニメーション
function animateFv() {
  const group01 = createGroup(['.animation-group-01--01', '.animation-group-01--02']);
  const group02 = createGroup(['.animation-group-02--01', '.animation-group-02--02']);
  const group03 = createGroup(['.animation-group-03--01', '.animation-group-03--02']);
  const group04 = createGroup(['.animation-group-04--01', '.animation-group-04--02', '.animation-group-04--03']);
  const group05 = createGroup(['.animation-group-05--01', '.animation-group-05--02', '.animation-group-05--03']);
  const group06 = createGroup(['.animation-group-06--01', '.animation-group-06--02', '.animation-group-06--03']);
  const group07 = createGroup(['.animation-group-07--01', '.animation-group-07--02']);
  const animationStatus = {
    group01: {
      'image-01': false,
      'image-02': false,
    },
    group02: {
      'image-01': false,
      'image-02': false,
    },
    group03: {
      'image-01': false,
      'image-02': false,
    },
    group04: {
      'image-01': false,
      'image-02': false,
      'image-03': false,
    },
    group05: {
      'image-01': false,
      'image-02': false,
      'image-03': false,
    },
    group06: {
      'image-01': false,
      'image-02': false,
      'image-03': false,
    },
    group07: {
      'image-01': false,
      'image-02': false,
    },
    reset: function (groupName) {
      for (const key in this[groupName]) {
        this[groupName][key] = false;
      }
    },
  }

  const animeController = (groupObj, groupName, animationType = 'series', animationInterval = 100, nextInterval = 100, cb) => {
    if (animationType === 'series') { // 順番にアニメーションを実行
      let counter = 1;

      animationSeries();
      function animationSeries() {
        if (Object.values(animationStatus[groupName]).includes(false) && counter <= Object.keys(groupObj).length) {
          const imgName = `image-0${counter}`;

          groupObj[imgName].classList.add('animate');
          groupObj[imgName].addEventListener('animationend', function animationListener() {
            this.classList.remove('animate');
            setTimeout(() => {
              counter++;
              animationStatus[groupName][imgName] = true;
              this.removeEventListener('animationend', animationListener);
              animationSeries();
            }, animationInterval);
          });
        } else {
          setTimeout(() => {
            animationStatus.reset(groupName);
            cb();
          }, nextInterval);
        }
      }
    } else if (animationType === 'parallel') { // 一度に複数の要素を動かす
      for (const key in groupObj) {
        groupObj[key].classList.add('animate');
        groupObj[key].addEventListener('animationend', (elm) => {
          animationStatus[groupName][key] = true;
          elm.target.classList.remove('animate');

          if (Object.values(animationStatus[groupName]).every(n => n === true)) {
            setTimeout(() => {
              animationStatus.reset(groupName);
              cb();
            }, nextInterval);
          }
        })
      }
    }
  }

  function createGroup(classNames) {
    const group = {};
    classNames.forEach((className, index) => {
      group[`image-0${index + 1}`] = document.querySelector(className);
    });
    return group;
  }

  animationLoop();
  async function animationLoop() {
    await new Promise(resolve => animeController(group01, 'group01', 'parallel', 0, 450, resolve));
    await new Promise(resolve => animeController(group02, 'group02', 'parallel', 150, 450, resolve));
    await new Promise(resolve => animeController(group03, 'group03', 'parallel', 150, 450, resolve));
    await new Promise(resolve => animeController(group04, 'group04', 'parallel', 150, 450, resolve));
    await new Promise(resolve => animeController(group05, 'group05', 'series', 150, 450, resolve));
    await new Promise(resolve => animeController(group06, 'group06', 'parallel', 150, 450, resolve));
    await new Promise(resolve => animeController(group07, 'group07', 'parallel', 150, 450, resolve));
    animationLoop();
  }
}

// fvのモーダル（吹き出しの表示管理）
ControlFvModal();
function ControlFvModal() {
  const windowSize = window.innerWidth;
  const modalToggleIcon = document.querySelectorAll('.shotei-icon');

  modalToggleIcon.forEach((elm, index, arr) => {
    const targetIcon = elm.firstElementChild;
    const targetModal = elm.lastElementChild;

    if (windowSize >= 750) { // 画面幅がPCの場合
      const modalTimer = {
        start(elm, className, timer = 400) {
          if (typeof this.timeoutID === 'number') {
            this.cancel();
          }

          this.timeoutID = setTimeout(() => {
            elm.classList.remove(className);
          }, timer);
        },

        cancel() {
          clearTimeout(this.timeoutID);
        }
      };

      // アイコンにマウスカーソルを合わせた時
      targetIcon.addEventListener('mouseover', () => {
        arr.forEach(e => { e.lastElementChild.classList.remove('active'); }); // 表示をリセット
        modalTimer.cancel();
        targetModal.classList.add('active');
      });

      // アイコンからマウスカーソルを外したとき
      targetIcon.addEventListener('mouseout', () => {
        modalTimer.start(targetModal, 'active');
      });

      // モーダルにマウスカーソルを合わせた時
      targetModal.addEventListener('mouseover', () => {
        modalTimer.cancel();
        targetModal.classList.add('active');
      });

      // モーダルからマウスカーソルを外したとき
      targetModal.addEventListener('mouseout', () => {
        modalTimer.start(targetModal, 'active');
      });
    } else { // 画面幅がSPの場合
      const spModal = document.querySelectorAll('.service-modal-sp');
      const spModalClose = document.querySelectorAll('.service-modal-sp__content p.close-button');

      modalToggleIcon.forEach((elm, index) => {
        elm.addEventListener('click', function () {
          spModal[index].classList.add('active');
        });
      });

      spModalClose.forEach((elm, index) => {
        elm.addEventListener('click', function () {
          spModal[index].classList.remove('active');
        });
      });
    }
  });
}

messageAutoScroll();
function messageAutoScroll() {
  const slider = new Splide('.message__slider', {
    arrows: false,
    pagination: false,
    fixedHeight: '30rem',
    autoWidth: true,
    type: 'loop',
    drag: false,
    gap: '4rem',
    autoScroll: {
      speed: 1.3,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
    },
    mediaQuery: "max",
    breakpoints: {
      749: {
        gap: '1.4rem',
        fixedHeight: '12rem',
      }
    }
  });

  slider.mount({ AutoScroll });
}

